import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    editAvatar: string;
    editAvatarIconLabel: string;
    defaultProjectName: string;
    addProjectName: string;
    projectNameLabel: string;
    avatarLoadError: string;
    restrictedLabel: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label for the avatar editor action */
            editAvatar: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectAvatarEditor.editAvatar?c=m32wpmcnpvan", defaultMessage: "Edit project avatar" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the edit avatar icon */
            editAvatarIconLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectAvatarEditor.editAvatarIconLabel?c=91jungmkwmt2", defaultMessage: "Edit Image" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Fallback project name when none is set */
            defaultProjectName: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectAvatarEditor.defaultProjectName?c=3lwyyx94sr8g7", defaultMessage: "Untitled Project" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Placeholder text for the project name input */
            addProjectName: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectAvatarEditor.addProjectName?c=37t0j07eksp2t", defaultMessage: "Add project name" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Accessible label for the project name input */
            projectNameLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectAvatarEditor.projectNameLabel?c=x1o02k3bb9jg", defaultMessage: "Project name" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Message shown when the avatar image fails to load */
            avatarLoadError: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectAvatarEditor.avatarLoadError?c=3ut04zoy4r65w", defaultMessage: "Failed to load. Try again." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Accessible label for the lock icon shown when a project is restricted */
            restrictedLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectAvatarEditor.restrictedLabel?c=25czo0kges3fk", defaultMessage: "Project is restricted" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
